import React, { useState } from "react";
import HobbliVisionModal from "./HobbliVisionModal";

export default function HobbliVisionLauncher({
    buttonText = "Launch HobbliVision",
    className = "",
    onItemConfirmed,
    currentUser,
}) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirmed = (item) => {
        if (onItemConfirmed) {
            onItemConfirmed(item);
        }

        setOpen(false);
    };

    return (
        <>
            <button
                className={`hv-launch-button ${className}`}
                onClick={() => setOpen(true)}
            >
                ✨ {buttonText}
            </button>

            <HobbliVisionModal
                open={open}
                user={{currentUser}}
                onClose={handleClose}
                onItemConfirmed={handleConfirmed}
            />
        </>
    );
}